
import { computed, defineComponent, getCurrentInstance, ref } from 'vue'
import api from '../../api/api'
import { clientFormHelper } from './helpers'
import phoneValidator, { isValidPhone } from '@/helpers/validators/phoneValidator'
import ValidationInput from '@/components/inputs/ValidationInput.vue'

export default defineComponent({
    components: { ValidationInput },
    props: {
        reason: {
            type: String,
            required: true,
        },
        extra: {
            type: null,
        },
    },
    setup(props, { emit }) {
        const root = getCurrentInstance()!.proxy
        const loading = ref(false)
        const projectId = computed(() => root.$route.params.id)
        const answers = ref({
            phone: '',
            functions: [],
            businessType: null,
            customBusinessType: '',
        })
        const q1Answers = [
            { id: 1, name: 'Автоматизированно рассылать напоминания о записях клиентам' },
            { id: 2, name: 'Автоматизированно получать отзывы и подтверждения записей от клиентов' },
            { id: 3, name: 'Организовать обзвон клиентов по сегментам' },
            { id: 4, name: 'Мотивировать сотрудников на обзвон клиентов по сегментам' },
            { id: 5, name: 'Делать рассылки клиентам по сегментам' },
            { id: 6, name: 'Анализировать работу сотрудников по возвращению клиентов' },
            { id: 7, name: 'Анализировать состояние моего бизнеса' },
        ]
        const q2Answers = [
            { id: 1, name: 'Барбершоп' },
            { id: 2, name: 'Салон красоты' },
            { id: 3, name: 'Маникюрная студия' },
            { id: 4, name: 'Студия эпиляции' },
            { id: 5, name: 'Косметологическая клиника' },
            { id: 6, name: 'Стоматологическая клиника' },
            { id: 7, name: 'Многопрофильная клиника' },
            { id: 8, name: 'Прочее' },
        ]

        const saveAnswers = async () => {
            if (!isValidPhone(answers.value.phone) || loading.value) return
            loading.value = true
            try {
                const mappedAnswers = clientFormHelper.mapAnswers(props.reason, answers.value, {
                    q1Answers,
                    q2Answers,
                })

                await api.clientForm.saveAnswers({
                    answers: answers.value,
                    reason: props.reason,
                    mappedAnswers,
                    projectId: projectId.value,
                    extra: props.extra,
                })
                emit('answers-saved')
            } finally {
                loading.value = false
            }
        }

        return { q1Answers, q2Answers, answers, loading, saveAnswers, isValidPhone, phoneValidator }
    },
})
